
import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid, ButtonBase, Typography, } from '@material-ui/core';
import Apis from '../../network/Apis';
import SubscribeItem from './view/SubscribeItem';
import Swiper from 'react-id-swiper';
import MatchItem from '../match/view/MatchItem';
import DateUtils from '../../control/dateutils';
import AppData from '../../model/AppData';
import AppUtils from '../../control/apputlis';

const ICON = require("../../images/icons/shaixuan.png");

class SubscribeMatch extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            leagueData: [],
            hotData: [],
            value: 0,
            selectedIndex: 0,
            matchNums: 0,
        };
        this.params = {
            slidesPerView: 'auto',
            spaceBetween: 8,
        };
    }

    componentDidMount() {
        AppUtils.YMPush('MAIN', 'SubscribeMatch');
        this.starLeague();
        this.getHotMatch();
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    starLeague = async () => {
        if (!AppData.me.isLogin()) {
            return;
        }
        let result = await Apis.encryptionShowFocusLeague();
        console.log('starLeague', result);
        if (result.code == 200) {
            let matchNums = 0;
            for (let i = 0; i < result.data.length; i++) {
                matchNums += result.data[i].match.length;
            }
            let data = result.data.sort((a, b) => {
                return b.match.length - a.match.length;
            })
            this.setState({ leagueData: data, matchNums: matchNums });
        }
    }

    getHotMatch = async () => {
        let result = await Apis.encryptionRecommMatch();
        console.log('getHotMatch', result);
        if (result.code == 200) {
            this.setState({ hotData: result.data });
        }
    }

    _onItemClick = (val) => {
        this.setState({ selectedIndex: val })
    }

    _onClickMdy = () => {
        this.props.history.push('/subscribechannel');
    }

    _onClickLogin = () => {
        this.props.history.push('/login');
    }

    _renderNoLogin() {
        const { classes } = this.props;
        return (
            <Grid container direction='column' alignItems='center' justify='center' style={{ height: '26vw' }}>
                <Typography style={{ fontSize: 12, color: '#878787' }}> 登录后可查看关注联赛 </Typography>
                <ButtonBase onClick={() => this._onClickLogin()} className={classes.loginButton}>去登录</ButtonBase>
            </Grid>
        );
    }

    _renderLogin() {
        const { classes } = this.props;
        const { matchNums } = this.state;
        return (
            <Grid container direction='row' alignItems='center' justify='space-between' style={{ marginTop: 12 }}>
                <Grid container direction='row' alignItems='center' style={{ flex: 1 }}>
                    <Typography style={{ fontSize: 14, color: '#0D0D0D', fontWeight: 'bold', marginLeft: 8 }}>我关注的联赛</Typography>
                    <Typography style={{ fontSize: 12, color: '#878787', marginLeft: 4 }}>{"近期共" + matchNums + "场"}</Typography>
                </Grid>
                <Grid container direction='row' alignItems='center' justify='flex-end' style={{ flex: 1 }}>
                    <ButtonBase onClick={() => this._onClickMdy()} className={classes.dyButton}>修改</ButtonBase>
                </Grid>
            </Grid>
        );
    }

    render() {
        const { classes } = this.props;
        const { leagueData, hotData, selectedIndex, matchNums } = this.state;
        let match = [];
        if (leagueData && leagueData.length > 0) {
            match = leagueData[selectedIndex].match
        }
        return (
            <Grid container direction='column' alignItems='center' style={{ flex: 1, backgroundColor: '#FFF' }}>
                <Grid container direction='column' alignItems='center' justify='center'>
                    {
                        AppData.me.isLogin() ? this._renderLogin() : this._renderNoLogin()
                    }
                    <Grid container direction='row' alignItems='center' style={{ width: '100vw', paddingTop: 12, paddingBottom: 12 }}>
                        <Swiper {...this.params} >
                            {
                                leagueData.map((item, i) => (
                                    <Grid key={i} container alignItems='center' justify='center' style={{ paddingLeft: 12, width: 90 }}>
                                        <SubscribeItem selected={i == selectedIndex} onClick={() => this._onItemClick(i)} key={i} data={item} />
                                    </Grid>
                                ))
                            }
                        </Swiper>
                    </Grid>
                    <Grid container direction='column' alignItems='center' style={{ width: '100vw', paddingTop: 12, paddingBottom: 12 }}>
                        {
                            match.length > 0 && match.map((item, i) => (
                                <MatchItem key={i} data={item} line={true} />
                            ))
                        }
                    </Grid>
                    <Grid container direction='row' alignItems='center' style={{ width: '100vw', paddingTop: 0, paddingBottom: 0 }}>
                        <Grid container direction='row' alignItems='center'>
                            <Typography style={{ fontSize: 14, color: '#0D0D0D', fontWeight: 'bold', marginLeft: 8 }}>今日热门</Typography>
                            <Typography style={{ fontSize: 12, color: '#878787', marginLeft: 8 }}>{DateUtils.dateFormatMD()}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container direction='column' alignItems='center' style={{ width: '100vw', paddingTop: 0, paddingBottom: 88 }}>
                        {
                            hotData.length > 0 && hotData.map((item, i) => (
                                <MatchItem key={i} data={item} line={true} />
                            ))
                        }
                    </Grid>
                </Grid>
            </Grid>
        );
    }

}

export default withRouter(withStyles((theme) => ({
    league: {
        padding: theme.spacing(0, 1, 0, 1)
    },
    dyButton: {
        minWidth: 64,
        backgroundColor: '#EDEAFD',
        height: 25,
        borderRadius: 12.5,
        marginRight: 8,
        color: theme.palette.primary.main,
        fontSize: 12,
        marginTop: 4,
    },
    loginButton: {
        minWidth: 64,
        backgroundColor: theme.palette.primary.main,
        height: 25,
        borderRadius: 12.5,
        marginRight: 8,
        color: '#FFF',
        fontSize: 12,
        marginTop: 4,
    },
}))(SubscribeMatch));